module.exports = __webpack_public_path__ + "static/media/remove-default.eab1f184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/remove-default.svg
// module id = 935
// module chunks = 0